<div>
 <div class="raised-div">
    <div class="display-flex">
        <span class="flex-1"><strong>Full Description</strong></span>
    </div>
    <div class="flex-1">
        <span [ngClass]="{'red': this.getSubstance() == '[Substance]', 'darkGreen': this.getSubstance() != '[Substance]'}">{{ this.getSubstance() }}</span>
        <span> as </span>
        <span class="blue">{{ this.getRole() }}</span>
        <span class="blue"> {{ this.getStrength()}}</span>
        <span *ngIf="this.getStrength() != ''"> 
            <span>&nbsp;</span>
            <span [ngClass]="{'red': this.getLowNumerator() == '[value]', 'darkGreen': this.getLowNumerator() != '[value]'}">{{ this.getLowNumerator() }}</span>
            <span>&nbsp;</span>
            <span *ngIf="!this.getPrefixUnit()" [ngClass]="{'red': this.getLowNumeratorPrefix() == '[prefix]', 'blue': this.getLowNumeratorPrefix() != '[prefix]'}">{{ this.getLowNumeratorPrefix() }}</span>
            
            <span *ngIf="selectedNode.data.model.concentrationtypecode?.value == 2">
                <span> to </span>
                <span [ngClass]="{'red': this.getHighNumerator() == '[value]', 'darkGreen': this.getHighNumerator() != '[value]'}">{{ this.getHighNumerator() }}</span>
                <span>&nbsp;</span>
                <span *ngIf="!this.getPrefixUnit()" [ngClass]="{'red': this.getHighNumeratorPrefix() == '[prefix]', 'blue': this.getHighNumeratorPrefix() != '[prefix]'}">{{ this.getHighNumeratorPrefix() }}</span>
            </span>             
            <span>&nbsp;</span>
            <span *ngIf="this.getPrefixUnit()">{{ this.getLowNumeratorPrefix() }}</span>
            <span>&nbsp;</span>
            <span [ngClass]="{'red': this.getLowNumeratorUnit() == '[unit]', 'blue': this.getLowNumeratorUnit() != '[unit]'}">{{ this.getLowNumeratorUnit() }}</span>
            <span> per </span>
            <span [ngClass]="{'red': this.getLowDenominator() == '[value]', 'darkGreen': this.getLowDenominator() != '[value]'}">{{ this.getLowDenominator() }}</span>
            <span>&nbsp;</span>
            <span [ngClass]="{'red': this.getLowDenominatorPrefix() == '[prefix]', 'blue': this.getLowDenominatorPrefix() != '[prefix]'}">{{ this.getLowDenominatorPrefix() }}</span>
            <span>&nbsp;</span>
            <span [ngClass]="{'red': this.getLowDenominatorUnit() == '[unit]', 'blue': this.getLowDenominatorUnit() != '[unit]'}">{{ this.getLowDenominatorUnit() }}</span>
        </span>
    </div>
<br>    
<div class="display-flex">
    <span class="flex-1"><strong>Concise:</strong>
        <span *ngIf="this.getStrength() != ''"> 
            <span>&nbsp;</span>
            <span [ngClass]="{'red': this.getSubstance() == '[Substance]', 'darkGreen': this.getSubstance() != '[Substance]'}">{{ this.getSubstance() }}</span>
            <span>&nbsp;</span>
            <span [innerHTML]="getConentrationTypeSortLeft()"></span>
            <span>&nbsp;</span>
            <span [ngClass]="{'red': this.getLowNumerator() == '[value]', 'darkGreen': this.getLowNumerator() != '[value]'}">{{ this.getLowNumerator() }}</span>
            <span *ngIf="this.selectedNode.data.model.concentrationtypecode?.value == 6" [innerHTML]="getConentrationTypeSortRight()"></span>
            <span>&nbsp;</span>
            <span *ngIf="!this.getConcisePrefixUnit()" [ngClass]="{'red': this.getConciseLowNumeratorPrefix() == '[prefix]', 'blue': this.getConciseLowNumeratorPrefix() != '[prefix]'}">{{ this.getConciseLowNumeratorPrefix() }}</span>            
            <span *ngIf="selectedNode.data.model.concentrationtypecode?.value == 2">         
                <span [innerHTML]="getConentrationTypeSortRight()"></span>
                <span [ngClass]="{'red': this.getHighNumerator() == '[value]', 'darkGreen': this.getHighNumerator() != '[value]'}">{{ this.getHighNumerator() }}</span>
                <span>&nbsp;</span>
                <span *ngIf="!this.getConcisePrefixUnit()" [ngClass]="{'red': this.getConciseHighNumeratorPrefix() == '[prefix]', 'blue': this.getConciseHighNumeratorPrefix() != '[prefix]'}">{{ this.getConciseHighNumeratorPrefix() }}</span>
            </span>           
            <span>&nbsp;</span>
            <span *ngIf="this.getConcisePrefixUnit()">{{ this.getConciseLowNumeratorPrefix() }}</span>
            <span [ngClass]="{'red': this.getConciseLowNumeratorUnit() == '[unit]', 'blue': this.getConciseLowNumeratorUnit() != '[unit]'}">{{ this.getConciseLowNumeratorUnit() }}</span>
            <span> / </span>
            <span [ngClass]="{'red': this.getLowDenominator() == '[value]', 'darkGreen': this.getLowDenominator() != '[value]'}">{{ this.getLowDenominator() }}</span>
            <span>&nbsp;</span>
            <span [ngClass]="{'red': this.getConciseLowDenominatorPrefix() == '[prefix]', 'blue': this.getConciseLowDenominatorPrefix() != '[prefix]'}">{{ this.getConciseLowDenominatorPrefix() }}</span>
            <span>&nbsp;</span>
            <span [ngClass]="{'red': this.getConciseLowDenominatorUnit() == '[unit]', 'blue': this.getConciseLowDenominatorUnit() != '[unit]'}">{{ this.getConciseLowDenominatorUnit() }}</span>
        </span>
    </span>
</div>
</div>
<br>
<div *ngIf="(selectedNode && selectedNode.data.fields.length > 0)">
    <formly-form [form]="selectedNode.data.form" 
                 [fields]="selectedNode.data.fields" 
                 [model]="selectedNode.data.model"
                 [selectedNode]="selectedNode"
                 (modelChange)="onModelChange($event)">
    </formly-form>
</div>    
